<template>
  <section>
    <div class="update-list">
      <div>
        <div class="level">
          <div class="level-left">
            <h2>Updates and Tasks ({{ totalRecords }})</h2>
          </div>

          <div class="level-right">
            <a @click.prevent="filterUpdatesData">refine</a>
          </div>
        </div>
      </div>
      <div
        class="card is-dashboard-list dashboard-updates"
        :class="{ CustomerView: !hideCustomerView }"
      >
        <b-notification :closable="false">
          <ul class="card-content">
            <div
              class="has-text-grey has-text-centered"
              v-if="records.length == 0"
            >
              <p>
                <b-icon icon="emoticon-happy-outline" size="is-large" />
              </p>
              <p>No Updates or Tasks to show&hellip;</p>
            </div>
            <div
              class="item-container"
              v-for="(row, index) in records"
              :key="index"
            >
              <li>
                <article class="media">
                  <figure class="media-left">
                    <div class="updateIcon">
                      <div v-if="row.update_type == 'Task'">
                        <div class="task-icon">
                          <b-icon
                            icon="check-outline"
                            :type="{ 'is-success': row.isGreen }"
                            @click.native="changeTaskStatus(row)"
                          ></b-icon>
                        </div>
                      </div>
                      <div v-else>
                        <b-icon
                          icon="message-alert-outline"
                          type="is-info"
                        ></b-icon>
                      </div>
                    </div>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <div class="media-meta">
                        <div class="updates-title">
                          {{ row.text }}
                          <br />
                          <span v-if="row.text_body">
                            {{ row.text_body }}
                          </span>
                          <br />
                          <span
                            v-if="
                              (row.model == 'CDFTemplateCustomer' ||
                                row.model ==
                                  'CDFTransactionTemplateCustomer') &&
                                row.operation == 'Rejected'
                            "
                          >
                            <a @click.prevent="showComment(row)">{{
                              row.see_comment
                            }}</a>
                          </span>
                          <a @click.prevent="openView(row)">{{
                            row.text_link
                          }}</a>
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="media-right">
                    <div class="details">{{ row.formattedDate }} <br /></div>
                  </div>
                </article>
                <hr />
              </li>
            </div>
          </ul>
          <b-loading
            :is-full-page="false"
            v-model="isLoading"
            :can-cancel="true"
          ></b-loading>
        </b-notification>
      </div>
      <refine-updates-list
        :is-active="isRefineModalActive"
        @confirm="viewConfirm"
        @cancel="closeRefineModal"
      ></refine-updates-list>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardDataService from "../../services/DashboardDataService";
import UserDataService from "../../services/UserDataService";
import { UserGroup } from "../../services/UserGroups";
import RefineUpdatesList from "./RefineUpdatesList.vue";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { ref } from "vue";
// @group Dashboard
export default {
  name: "UpdatesList",
  mixins: [UtilityMixin, ScopeMixin],
  components: {
    RefineUpdatesList
  },
  props: {
    allUsers: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultView: {
      type: Boolean
    },
    hideCustomerView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dashboardDataService: new DashboardDataService(),
      userDataService: new UserDataService(),
      records: [],
      users: this.allUsers,
      update_count: 0,
      task_count: 0,
      isRefineModalActive: false,
      switchCustomerId: null,
      enableLoadMore: false,
      scrollheight: 0,
      totalRecords: 0,
      query: "",
      nextPageCursor: "",
      isLoading: false,
      defaultVeiwChanged: false
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    isUserAdminOrCAM() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    defaultView: function(newVal, oldVal) {
      this.defaultVeiwChanged = true;
      if (this.allUsers.length > 0) {
        this.fetchUpdatesList();
      }
    },
    allUsers(newVal) {
      this.users = newVal;
      this.fetchUpdatesList();
    }
  },
  mounted() {
    const listElm = document.querySelector(".dashboard-updates");
    listElm.addEventListener("scroll", e => {
      if (
        this.enableLoadMore &&
        Math.round(listElm.scrollTop) + Math.round(listElm.clientHeight) >=
          Math.round(listElm.scrollHeight * 0.9) &&
        this.scrollheight != Math.round(listElm.scrollHeight)
      ) {
        this.scrollheight = Math.round(listElm.scrollHeight);
        this.pullNextPage();
      }
    });
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
  },
  methods: {
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    pullNextPage() {
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query = this.nextPageCursor;
        this.nextPageCursor != this.PreviousPageCursor
          ? this.fetchUpdatesList()
          : "";
      }
    },
    changeTaskStatus(row) {
      row.isGreen = !row.isGreen;
      if (row.isGreen) {
        row.status = "Done";
      } else {
        row.status = "Read";
      }
      this.updateTaskStatus(row);
    },
    prepareUpdatesData(data) {
      this.task_count = 0;
      this.update_count = 0;
      for (const idx in data) {
        const updateData = data[idx];
        if (updateData["update_type"] == "Task") {
          this.task_count += 1;
          if (updateData["status"] == "Done") {
            updateData["icon"] = "check-bold";
            updateData["isGreen"] = true;
          } else {
            updateData["icon"] = "check-outline";
            updateData["isGreen"] = false;
          }
        } else {
          this.update_count += 1;
        }

        const responsibleUser = this.users.filter(
          e => e.id == updateData["responsible"]
        )[0];
        const month = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "July",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        const parsedDate = Date.parse(updateData["created_at"]);
        const createdAt = new Date(parsedDate);
        const formattedDate =
          createdAt.getDate() + " " + month[createdAt.getMonth()];
        let responsibleName = "";
        if (responsibleUser != undefined) {
          responsibleName =
            responsibleUser.first_name + " " + responsibleUser.last_name;
        }
        updateData["formattedDate"] = formattedDate;
        if (updateData["model"] == "Customer") {
          updateData["text_link"] = "See Customer Profile";
          if (this.isUserAdminOrCAM) {
            updateData["text_body"] = updateData["text_body"].replace(
              "You",
              responsibleName
            );
            updateData["text_body"] = updateData["text_body"].replace(
              "are",
              "is"
            );
          }
        }
        if (updateData["model"] == "CustomerUpdates") {
          updateData["text_link"] = "See Customer Update";
          if (this.isUserAdminOrCAM) {
            updateData["text_body"] = updateData["text_body"].replace(
              "You",
              responsibleName
            );
            updateData["text_body"] = updateData["text_body"].replace(
              "are",
              "is"
            );
          }
        } else if (updateData["model"] == "ReportTracker") {
          updateData["text_link"] = "See Report";
          if (this.isUserAdminOrCAM) {
            updateData["text_body"] = updateData["text_body"].concat(" (");
            updateData["text_body"] = updateData["text_body"].concat(
              responsibleName
            );
            updateData["text_body"] = updateData["text_body"].concat(")");
          }
        } else if (updateData["model"] == "Report") {
          updateData["text_link"] = "See Customers";
          if (this.isUserAdminOrCAM) {
            updateData["text_body"] = updateData["text_body"].concat(" for ");
            updateData["text_body"] = updateData["text_body"].concat(
              responsibleName
            );
          }
        } else if (updateData["model"] == "CountryStreamResponsible") {
          updateData["text_link"] = "See Country Support Overview";
          if (this.isUserAdminOrCAM) {
            updateData["text_body"] = updateData["text_body"].concat(" for ");
            8;
            updateData["text_body"] = updateData["text_body"].concat(
              responsibleName
            );
          }
        } else if (updateData["model"] == "UserReminders") {
          updateData["text_link"] = "See update";
        } else if (updateData["model"] == "CDFTemplateCustomer") {
          updateData["see_comment"] = "See Comment";
        } else if (updateData["model"] == "CDFTransactionTemplateCustomer") {
          updateData["see_comment"] = "See Comment";
        }
        data[idx] = updateData;
      }
      return data;
    },
    fetchUpdatesList(search = "") {
      this.isLoading = true;
      const updateListObserve = this.dashboardDataService.getUpdatesList(
        this.defaultView,
        search,
        this.switchCustomerId,
        this.query
      );
      updateListObserve.subscribe(
        response => {
          if (this.nextPageCursor != response["next"]) {
            this.nextPageCursor = response["next"]
              ? "&page=" + response["next"].split("&page=")[1]
              : null;

            this.totalRecords = response.count;
            if (this.defaultVeiwChanged) {
              this.records = [];
              this.defaultVeiwChanged = false;
            }
            this.records.push(...this.prepareUpdatesData(response.results));
            this.records = this.getUniqueListBy(this.records, "id");
            if (this.nextPageCursor != null) {
              this.enableLoadMore = true;
            } else {
              this.enableLoadMore = false;
            }
          }

          this.isLoading = false;

          //this.records = this.prepareUpdatesData(response);
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
      return updateListObserve;
    },
    updateTaskStatus(data) {
      this.dashboardDataService.updateDashboardUpdateStatus(data).subscribe(
        response => {
          console.log("Task status updated");
        },
        e => {
          console.log(e);
        }
      );
    },
    openView(data) {
      // Open reports or customer profile only in view mode
      if (data.model == "Customer") {
        const route = this.$router.resolve({
          name: "customers.view",
          params: { id: data.record_id }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "ReportTracker") {
        const route = this.$router.resolve({
          name: "reportingtracker.view",
          params: { id: data.record_id }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "Report") {
        const route = this.$router.resolve({
          name: "customers",
          params: { from_dashboard: data.record_ids }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "CountryStreamResponsible") {
        const route = this.$router.resolve({
          name: "reportingTracker.countryOverview",
          params: {}
        });
        window.open(route.href, "_blank");
      } else if (data.model == "CustomerUpdates") {
        const route = this.$router.resolve({
          name: "reportingtracker.customerUpdateViewFromDashboard",
          params: { id: data.record_id }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "UserReminders") {
        const route = this.$router.resolve({
          name: "customer.reminder",
          params: { id: data.id }
        });
        window.open(route.href, "_blank");
      } else {
        alert("No navigation identified yet");
      }
    },
    showComment(data) {
      this.$buefy.dialog.alert({
        title: "Comment for rejection",
        message: data.content,
        confirmText: "Close"
      });
    },
    viewConfirm(searchText, fromDate, toDate) {
      this.query = "";
      if (searchText) {
        this.query += "search_text=" + searchText + "&";
      }
      if (fromDate != null || fromDate != undefined) {
        this.query += "from_date=" + this.dateFormatter(fromDate) + "&";
      }
      if (toDate != null || toDate != undefined) {
        this.query += "to_date=" + this.dateFormatter(toDate) + "&";
      }
      this.records = [];
      this.fetchUpdatesList();
      this.isRefineModalActive = false;
    },
    filterUpdatesData() {
      this.isRefineModalActive = true;
    },
    closeRefineModal() {
      this.isRefineModalActive = false;
    }
  }
};
</script>
